import { gql } from '@apollo/client';
import textQueries from '../../ProductPage/textQueries';
import productQueries from '../../ProductPage/productQueries';

const GET_COLLECTION_DATA_QUERY = gql`
query Collection(
  $collectionId: String!,
  $productId: String!,
  $categoryId: String!,
  $faceout: String,
) {
  textFor {
    ${textQueries}
  }
  collection(collectionId: $collectionId, productId: $productId, faceout: $faceout) {
    collectionApiSuccess
    collection {
      ${productQueries}
    }
  }
  reviewData: bazaarVoice(collectionId: $collectionId, productId: $productId) {
    fitRecommendation
    showFitRecommendation
    hasBazaarVoiceEnable
    averageOverallRating
    reviewsSku
  }
  shippingContent {
    hasSimpleReturns
  }
  featureFlags {
    flags {
      name
      value
    }
  }
  config {
    helpPageLink: string(name: "helpPageLink")
  }
  content {
    pdpESpots(collectionId: $collectionId, categoryId: $categoryId) {
      pdp_sizefitguide { content key source }
      pdp_comparelengths { content key source }
      pdp_productdetails { content key source }
      pdp_afterproducttitle { content key source }
      pdp_beforeproducttitle { content key source }
      pdp_sizefitaccordion { content key source }
      pdp_aboveaccordion { content key source }
      pdp_aftersaveforlater { content key source }
      pdp_popins { content key source }
      pdp_belowthefold1 { content key source }
      pdp_belowthefold1 { content key source }
      pdp_howtomeasure { content key source }
      pdp_beforeaddtobag { content key source }
    }
    legacyPDPESpots(productId: $productId) {
      ProductPromoEMS { content key source }
      pdp_sizeGuideHowToMeasure { content key source }
    }
  }
}
`;

export default GET_COLLECTION_DATA_QUERY;
